module.exports = __webpack_public_path__ + "static/main-ca3602c55b2abd5bf5def855cd15f46f.jpg";